import { ComponentType, lazy } from "react";

/**
 * Returns a lazy component that has been imported from a non-default module.
 * @param name - The name of the import to be imported from the module.
 * @param promise - A promise that resolves to the module.
 * @returns - A lazy component that has been imported from a non-default module.
 */
export function mapLazy<P, K extends PropertyKey>(
  name: K,
  promise: Promise<{ [key in K]: ComponentType<P> }>,
) {
  return lazy(async function mapFactory() {
    const module = await promise;
    return { default: module[name] };
  });
}
